//@ts-check
import { Professions } from '../models/Professions'
import AbstractPiniaModel from './AbstractPiniaModel'
import { useViewStateStore } from '../pinia/stores/viewState'

/**
 * Attention: TestState is using the View(!)State-Store
 */
export class TestState extends AbstractPiniaModel {
    constructor(state) {
        super(state)
    }

    //#region Static Methods
    static piniaStore() {
        return useViewStateStore()
    }

    create(stateSource) {
        return new TestState(stateSource)
    }

    static hasStarted() {
        return this.piniaStore().testStartedAlready
    }
    static hasEnded() {
        return this.piniaStore().isTestOver
    }
    static isRunning() {
        return TestState.hasStarted() && !TestState.hasEnded()
    }
    static isRealTest() {
        return this.piniaStore().isRealTest
    }
    static isDemo() {
        return Professions.getSelected() && Professions.getSelected().isDemo()
    }

    static getCurrentView() {
        return this.piniaStore().currentView
    }

    static isCurrentView(view) {
        return this.piniaStore().currentView === view
    }
    static isInResultsMode() {
        return this.piniaStore().inResultsMode
    }

    static setCurrentViewTo(view) {
        this.dispatch('changeViewTypeTo', view)
    }

    static startTest(isRealTest = false) {
        this.dispatch('startTest', { isRealTest: isRealTest })
    }
    static endTest() {
        this.dispatch('endTest')
    }
    static reset(isRealTest = false) {
        this.dispatch('resetTestState')
        this.dispatch('configureRealTest', isRealTest)
    }
    //#endregion Static Methods
}
